import React from "react";
import { FiMenu, FiX } from "react-icons/fi";

/**
 * Logo Component for Admin Sidebar
 * Displays brand logo with collapse toggle
 */
const Logo = ({ isCollapsed, toggleSidebar }) => {
  return (
    <div className="pt-6 pb-4 px-4 border-b border-white/20">
      <div className="flex items-center justify-between">
        {/* Logo */}
        <div
          className={`flex items-center ${
            isCollapsed ? "justify-center w-full" : "space-x-3"
          }`}
        >
          <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-lg flex-shrink-0">
            <h1 className="text-primary text-lg font-bold font-Inter">MR</h1>
          </div>
          {!isCollapsed && (
            <div className="overflow-hidden">
              <h2 className="text-white text-base font-bold font-Inter whitespace-nowrap">
                Makalu Rudraksh
              </h2>
              <p className="text-white/60 text-xs whitespace-nowrap">
                Admin Panel
              </p>
            </div>
          )}
        </div>

        {/* Toggle Button */}
        {!isCollapsed && (
          <button
            onClick={toggleSidebar}
            className="p-1.5 hover:bg-white/10 rounded-lg transition-colors text-white/80 hover:text-white"
          >
            <FiX className="text-xl" />
          </button>
        )}
      </div>

      {/* Collapsed Toggle Button */}
      {isCollapsed && (
        <button
          onClick={toggleSidebar}
          className="w-full mt-3 p-2 hover:bg-white/10 rounded-lg transition-colors text-white/80 hover:text-white"
        >
          <FiMenu className="text-xl mx-auto" />
        </button>
      )}
    </div>
  );
};

export default Logo;
